export const zhCNStr = 'zh-CN';
export const enUSStr = 'en-US';
export const IOSSystemStr = 'iOS';
export const AndroidOSStr = 'AndroidOS';
export const entryUrlStr = 'entryUrl';
export const collaborationClientType = 2 //pdf 协同编辑时 客户端标识  1 pc 2 微信公众号 3 app 端